import React from 'react'
import N2FroalaBox from './N2FroalaBox'

class DesignerAnnotationCommentBox extends React.Component {
  render() {
    return (
      <div className="card-block px-1 pb-2 separator pb-0">
        <div className="d-flex flex-row">
          <div className="d-flex flex-column w-100">
            <N2FroalaBox
              klass={this.props.klass}
              onChange={this.props.handleMessageChange}
              comment={this.props.comment}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default DesignerAnnotationCommentBox
